<template>
  <div id="app">
    <!-- 顶部导航 -->
    <div id="web_bg" :style="{'backgroundImage' : headerBg ? 'url(' + headerBg + ')' : ''}"></div>
    <nav class="navbar container navbar-inverse " :class="{'backtest':show}">
      <div class="container-fluid none-padding">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header ">
          <button id="ssss" type="button" class="navbar-toggle collapsed button-border" data-toggle="collapse"
                  data-target="" aria-expanded="false" @click="showNav">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <template  v-if="logoImg">
            <img v-if="logoImg" class="logo" :src="logoImg" >
          </template>
          <template v-else>
            <img src="./assets/image/logo.png" class="logo" alt="">
          </template>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse  navbar-right none-padding" id="bs-example-navbar-collapse-1">
          <div class="header-top">
            <ul>
              <li><a  href="mailto:Quiz@delta-asia.com"><img src="./assets/image/email.png"></a></li>
              <!--<li><img src="./assets/image/wechat.png"></li>-->
              <li class="fb-right-width"><a target="_blank" href="https://www.facebook.com/%E6%BB%99%E6%A5%AD%E7%9B%83-455469194471178/"><img src="./assets/image/fb.png"></a></li>
              <li class="search">
                <!-- ******************搜索框***************** -->
                <!--<router-link :to="{path: 'new-message', query: {kw: keyWord}}" >-->
                <a @click="selectArticle" style="cursor: pointer">
                <!--<button type="submit">-->
                  <!--<img src="./assets/image/search.png">-->
                  <span class="glyphicon glyphicon-search select-btn" style="color: #4E7DF4;"></span>
                </a>
                <!--</button>-->
                <!--</router-link>-->
                <input type="text" v-model="keyWord" style="width: 200px; height: 33px;">
              </li>
            </ul>
          </div>
          <div class="header-nav-item ">
            <ul class="nav navbar-nav">
              <li>
                <router-link to="/" class="router-style">主頁</router-link>
              </li>
              <li>
                <router-link to="/introduct" class="router-style">滙業盃簡介</router-link>
              </li>
              <li>
                <router-link to="/new-message" class="router-style">最新消息</router-link>
              </li>
              <li >
                <router-link to="/titbits" class="router-style">比賽花絮</router-link>
              </li>
              <li id="titlbs"><a href="" data-toggle="dropdown" class="router-style">互動專區</a>
                <ul id="child-menu" class="dropdown-menu">
                  <li>
                    <router-link to="/common-sense">線上常識問答比賽</router-link>
                  </li>
                  <li v-for="(activity) in activitys" :key="activity.id">
                    <router-link :to="{path: 'activity-rules', query: {id:activity.id}}">{{activity.name}}</router-link>
                  </li>
                </ul>
              </li>
              <li>
                <router-link to="/enrolls" class="router-style">滙業盃專區</router-link>
              </li>
              <li>
                <router-link to="/news" class="router-style">傳媒中心</router-link>
              </li>
            </ul>
          </div>
        </div><!-- /.navbar-collapse -->
      </div><!-- /.container-fluid -->
    </nav>
    <!--移动端导航-->
    <index-nav ref="nav"></index-nav>
    <!-- 中间部分 -->
    <router-view/>
    <!-- 页脚 -->
    <div class="footer col-xs-12" :style="{'backgroundImage' : footerBg ? 'url(' + footerBg + ')' : ''}">

      <div class="content col-xs-10 hidden-xs col-sm-7" >
        <ul class="col-xs-5 col-sm-2">
          <li class="circle">本會介紹</li>
          <hr>
          <li><router-link to="/introduct">滙業盃簡介</router-link></li>
          <!--<li>理事長的話</li>-->
        </ul>
        <ul class="col-xs-5 col-sm-2">
          <li class="circle">最新消息</li>
          <hr>
          <li><router-link to="/events">賽事動態</router-link></li>
          <li><router-link to="/activity">其他活動</router-link></li>
        </ul>
        <ul class="col-xs-5 col-sm-2">
          <li class="circle">比賽花絮</li>
          <hr>
          <router-link to="/all-titbits">
          <li>歷届花絮</li>
          <li>－短片</li>
          <li>－相片集</li></router-link>
        </ul>

        <ul class="col-xs-5 col-sm-2">
          <li class="circle">滙業盃專區</li>
          <hr>
          <li><router-link to="/huiye-rule">比賽簡介規章</router-link></li>
          <li><router-link to="/huiye">網上報名</router-link></li>
          <li><router-link to="/download">下載表格</router-link></li>
        </ul>

        <ul class="col-xs-5 col-sm-2">
          <li class="circle">互動專區</li>
          <hr>
          <li><router-link to="/common-sense">線上常識問答比賽</router-link></li>
          <li>其他活動</li>
        </ul>
        <ul class="col-xs-5 col-sm-2">
          <li class="circle">傳媒中心</li>
          <hr class="last-hr">
          <li><router-link to="/news">本會新聞</router-link></li>
          <li><router-link to="/report">傳媒報道</router-link></li>
          <li><router-link to="/director-logs">理事長網誌</router-link></li>
        </ul>
      </div>
      <div class="call-me col-xs-12 hidden-xs col-sm-3">
        <ul>
          <li>聯絡我們</li>
          <hr>
          <li>電話: 8796-9781</li>
          <li>傳真: 8796-9798</li>
          <li>電郵: Quiz@delta-asia.com</li>
        </ul>
      </div>
      <!--手机版-->
      <div class="col-xs-12 visible-xs" style="text-align: center">
        <div class="col-xs-7 none-padding one-footer"><span class="white-circle-mobile"></span>本會介紹</div>
        <div class="col-xs-5 none-padding one-footer text-left"><span class="white-circle-mobile"></span>互動專區</div>
        <hr class="col-xs-11" style="margin: 0px">
        <div class="col-xs-7 none-padding one-footer">滙業盃簡介</div>
        <div class="col-xs-5 none-padding one-footer text-left">線上常識問答比賽</div>
        <div class="col-xs-7 none-padding "></div>
        <div class="col-xs-5 none-padding text-left">其他活動</div>
      </div>
      <div class="col-xs-12 visible-xs" style="text-align: center;margin-top: 10px">
        <div class="col-xs-7 none-padding one-footer"><span class="white-circle-mobile"></span>最新消息</div>
        <div class="col-xs-5 none-padding one-footer text-left"><span class="white-circle-mobile"></span>滙業盃專區</div>
        <hr class="col-xs-11" style="margin: 0px">
        <div class="col-xs-7 none-padding one-footer">賽事動態</div>
        <div class="col-xs-5 none-padding one-footer text-left">比賽簡介規章</div>
        <div class="col-xs-7 none-padding ">滙業盃活動</div>
        <div class="col-xs-5 none-padding text-left">網上報名</div>
        <div class="col-xs-7 none-padding "></div>
        <div class="col-xs-5 none-padding text-left" style="margin-top: 10px">下載表格</div>
      </div>
      <div class="col-xs-12 visible-xs" style="text-align: center;margin-top: 10px">
        <div class="col-xs-7 none-padding one-footer"><span class="white-circle-mobile"></span>比賽花絮</div>
        <div class="col-xs-5 none-padding one-footer text-left"><span class="white-circle-mobile"></span>傳媒中心</div>
        <hr class="col-xs-11" style="margin: 0px">
        <div class="col-xs-7 none-padding one-footer">歷屆花絮</div>
        <div class="col-xs-5 none-padding one-footer text-left">本會新聞</div>
        <div class="col-xs-7 none-padding ">-短片</div>
        <div class="col-xs-5 none-padding text-left">傳媒報導</div>
        <div class="col-xs-7 none-padding " style="margin-top: 10px">-相片集</div>
        <div class="col-xs-5 none-padding text-left" style="margin-top: 10px">理事長網誌</div>
        <div class="col-xs-5 none-padding text-left"></div>
      </div>
      <div class="col-xs-12 visible-xs" style="text-align: center;margin-top: 10px">
        <div class="col-xs-7 none-padding one-footer"><span class="white-circle-mobile"></span>聯絡我們</div>
        <div class="col-xs-5 none-padding one-footer text-left"></div>
        <hr class="col-xs-11" style="margin: 0px">
        <div class="col-xs-8 none-padding one-footer">電話: 8796-9781</div>
        <!--<div class="col-xs-5 none-padding one-footer text-left"></div>-->
        <div class="col-xs-8 none-padding ">傳真: 8796-9798 </div>
        <!--<div class="col-xs-5 none-padding text-left"></div>-->
        <div class="col-xs-10 none-padding " style="margin-top: 10px">電郵: Quiz@delta-asia.com</div>
      </div>
      <div class="copyright"><span>Copyright © 2018 澳門滙業盃常識問答比賽</span></div>
    </div>
  </div>
</template>

<script>
import indexNav from '@/components/indexNav.vue'
export default {
  name: 'App',
  data () {
    return {
      headerBg: '',
      footerBg: '',
      keyWord: '',
      logoImg: '',
      show: false,
      current: 1,
      activitys: []
    }
  },
  components: {
    'index-nav': indexNav
  },
  methods: {
    changeVal: function () {
      var that = this
      if (this.show) {
        this.$nextTick(function () {
          setTimeout(function () {    // 延迟执行，动画流畅
            that.show = false
          }, 350)
        })
      } else {
        this.show = true
      }
    },
    showNav: function () {
      this.$refs.nav.show()
    },
    getAllActivity: function () {
      var that = this
      this.$axios.get('/activity/name')
        .then(function (response) {
          that.activitys = response.data.data
          // console.log(that.activitys)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    selectArticle: function () {
      var that = this
      this.$router.push({name: 'new-message', query: {kw: that.keyWord}})
      this.$router.go(0)
    }
  },
  mounted () {
    this.getAllActivity()
    var that = this
    // 获取所有的
    this.$axios.get('other/list')
      .then(function (response) {
        that.logoImg = response.data.data[1].value
        that.headerBg = response.data.data[3].value
        that.footerBg = response.data.data[4].value
        // that.computeTime()
        // console.log(response.data)
      })
      .catch(function (error) {
        console.log(error)
      })
    $(function() {
      $("#titlbs").on("mouseover", function () {
        $(".dropdown-menu").show()
      })
      $("#titlbs").on("mouseout", function () {
        $(".dropdown-menu").hide()
      })
    })
  }
}
</script>

<style>
  #app {
    width: 100%;
    font-family: PingFangSC-Medium;
  }

  #web_bg {
    background-image: url(header_background.png);
    position: absolute;
    /*overflow-y:scroll;*/
    top: 0;
    left: 0;
    width: 100%;
    /*height:100%;*/
    min-height: 670px;
    z-index: -10;
    zoom: 1;
    /*background-color: #fff;*/
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -o-background-size: cover;
    background-position: center 0;
    /*background-attachment:fixed;*/
  }

  .navbar-inverse {
    border: none;
    background-color: rgba(0, 0, 0, 0);
  }

  .navbar-inverse .navbar-toggle {
    border-color: rgba(0,0,0,0);
    margin-right: 8px;
  }

  .navbar-inverse .navbar-toggle:focus, .navbar-inverse .navbar-toggle:hover {
    border-color: #fff;
    border-color: rgba(0,0,0,0);
    background-color: rgba(0, 0, 0, 0);
  }

  .navbar-inverse .navbar-collapse, .navbar-inverse .navbar-form {
    border-color: rgba(0, 0, 0, 0);
  }

  .icon-bar {
    background-color: #fff;
  }

  .logo {
    position: absolute;
    float: left;
    max-width: 400px;
    z-index: -5;
    overflow-y: scroll;
    /*margin-left: 40px;*/
    margin-top: 60px;
  }

  .navbar-collapse {
    margin-top: 20px;
  }

  /*顶部图标、搜索框*/
  .header-top {
    float: right;
    margin-bottom: 40px;
  }

  .header-top ul li {
    display: inline-block;
    margin-left: 10px;
  }

  .header-top .fb-right-width{
    margin-right: -25px;
  }
  .search {
    display: inline;
  }

  .search a {
    position: relative;
    left: 32px;
    top: 1px;
    background-color: rgba(0, 0, 0, 0);
    border-color: rgba(0, 0, 0, 0);
  }
  .search .select-btn{
    width: 19px;height: 19px;
  }

  .search input {
    border-radius: 20px;
    border-color: rgba(0, 0, 0, 0);
    padding-left: 25px;
  }

  /*顶部导航菜单*/
  .header-nav-item {
    display: inline-block;
    width: 100%;
  }
  .header-nav-item ul{
    float: right;
  }
  .header-nav-item ul li .router-style {
    letter-spacing: 0;
    display: inline;
    font-size: 16px;
    color: #FFFFFF;
  }

  #titlbs ul li{
    margin: 5px 0px;
  }

  /*頁腳*/
  .footer {
    background: url(footer_background.png);
    border-top: 5px solid rgba(74, 74, 74, 0.27);
    width: 100%;
    height: 200px;
    padding: 0;
    color: #ffffff;
    font-size: 12px;
  }

  .footer .content {
    margin-left: 10%;
    margin-top: 1%;
  }

  .footer .content a{
    color: #FFFFFF;
  }

  .footer .content ul {
    padding-left: 0px;
    padding-right: 0px;
  }

  .footer .content li, .footer .call-me li {
    /*display: inline;*/
    list-style-type: none;
  }

  .footer .content .circle {
    list-style-type: disc;
  }

  .footer .call-me {
    margin-top: 1%;
  }


  .footer .copyright {
    position: absolute;
    height: 40px;
    width: 100%;
    bottom: 0%;
    background: rgba(74, 74, 74, 0.27);
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
  }
  .one-footer{
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .one-footer hr{
    margin: 0px;
  }

  .white-circle-mobile{
    background: #fff;
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 4px;
    margin-right: 4px;
    margin-bottom: 3px;
  }

  @media (min-width: 1200px) {

  }

  @media (max-width: 1200px) {
    .logo {
      width: 300px;
      margin-left: 20px;
    }

    .header-nav-item ul li {
      /*margin-left: 20px;*/
    }
  }

  @media (max-width: 992px) {
    .logo {
      width: 250px;
    }

    .header-nav-item ul li {
      margin-left: 8px;
    }

  }

  @media (min-width: 768px) {
    /*導航條選擇時的樣式*/
    .navbar-inverse .navbar-nav > li > a:hover, .navbar-inverse .navbar-nav > li > a:focus {
      background: #FFFFFF;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50);
      border-radius: 100px;
      color: #343434;

    }
    .navbar-inverse .navbar-nav > .open > a {
      border-radius: 100px;
    }

    .navbar-inverse .navbar-nav > .open > a:active{
      background: #FFFFFF;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50);
      color: #343434;
    }

    #titlbs a:hover{
      background: #69D3C2;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50);
      color: #343434;
    }

    .navbar-inverse .navbar-nav > .open > a:visited {
      color: #343434;
      background: #69D3C2;
    }

    /*-------------end-----------------*/
    /*互动专区子菜单*/
    .navbar-nav > li > .dropdown-menu {
      position: absolute;
      left: -35px;
      margin-top: 30px;
      background: #FFFFFF;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50);
      border-radius: 7px;
    }

    .navbar-nav > li > .dropdown-menu::after { /*箭头*/
      content: "";
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -8px;
      border-width: 10px;
      border-style: solid;
      border-color: transparent transparent #D8D8D8 transparent;
    }

    .dropdown-menu > li > a {
      white-space: normal;
      text-align: center;
    }

     .dropdown-menu > li > a:hover, .dropdown-menu > li > a:active {
      color: #FFFFFF;
      background: #617BE4;
    }
    #child-menu a:hover{
      color: #FFFFFF;
      background: #617BE4;
    }

    /*-------------end-------------*/
    .last-hr {
      width: 60px;
      margin-left: 0px;
    }
  }

  @media (max-width: 767px) {
    #web_bg {
      /*background-image: url(./assets/image/header_background_mobile.png);*/
      min-height: 300px;
    }

    .logo {
      /*width: 194px;*/
      max-width: 180px;
      margin-left: 10px;
      margin-top: 10px;
    }

    .search button {
      left: 38px;
      top: 1px;
    }
    .search input {
      width: 100px;
      height: 33px;
    }

    header-nav-item ul {
      height: 100%;
    }

    /*導航條 不滾動*/
    .navbar-collapse .in {
      overflow-y: visible;
    }

    .header-nav-item ul li {
      text-align: center;
      font-size: 14px;
    }

    .header-top {
      margin-top: 10px;
      text-align: center;
      float: none;
    }

    .footer {
      height: 550px;

    }

    .footer hr {
      height: 1px;
      border: none;
      border-top: 1px dashed #ffffff;

    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue